import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoCassa } from '@app/shared/models/cassa';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-tipo-cassa-select',
  templateUrl: './tipo-cassa-select.component.html',
  styleUrl: './tipo-cassa-select.component.scss'
})
export class TipoCassaSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string;
  @Input() bindAllObject: boolean = false;

  tipi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.tipi = this.utils.getInputSelectFromEnum(TipoCassa);
  }

}